import axios from 'axios'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { useEffect, useRef, useState } from 'react'
import { NavLink, Outlet } from 'react-router-dom'
import classNames from 'classnames'

import { requestFamilies } from '../../actions/familyActions'

import { ReactComponent as PersonIcon } from '../../assets/images/common/icons/person-icon.svg'
import { ReactComponent as FamilyIcon } from '../../assets/images/common/icons/family-icon.svg'

import colors from '../../assets/styles/globals.scss'
import classes from './MembersListLayout.module.scss'
import { requestGetAllStudents } from '../../actions/communitiesActions'
import { deserialize } from '../../utility/serialization'
import Loader from '../common/loader/Loader'


const MembersListLayout = () => {
  const abortController = useRef(null)
  const communityId = useSelector(state => state.user.current_user.communities[0].id)

  // TODO: Refactor using redux (slices) instead of outlet context
  const [loadedStudentsData, setLoadedStudentsData] = useState(null)
  const [loadedFamiliesData, setLoadedFamiliesData] = useState(null)
  const [familiesCount, setFamiliesCount] = useState(null)
  const [studentsCount, setStudentsCount] = useState(null)
  const [activeStudentsCount, setActiveStudentsCount] = useState(null)

  useEffect(() => {
    abortController.current = new AbortController()

    const actions = [
      requestFamilies(communityId, 1, 10, '', false, abortController.current?.signal),
      requestGetAllStudents(communityId, 1, 10, '', null, false, abortController.current?.signal),
    ]

    Promise.all(actions)
      .then(([familiesRes, studentsRes]) => {
        const familiesData = deserialize(familiesRes.data)
        const studentsData = deserialize(studentsRes.data)

        setLoadedFamiliesData(familiesData)
        setLoadedStudentsData(studentsData)
        setFamiliesCount(familiesData.meta.pagination.totalCount)
        setStudentsCount(studentsData.meta.pagination.totalCount)
        setActiveStudentsCount(studentsData.meta.activeStudentsCount)
      })
      .catch((res) => {
        if (!axios.isCancel(res)) {
          toast.error('Something went wrong. Please try again.', { position: toast.POSITION.TOP_RIGHT })
        }
      })

    return () => abortController.current.abort()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const isMembersDataLoaded = !!loadedFamiliesData && loadedStudentsData

  return (
    <section className={classes.membersList}>
      <div className={classes.subHeader}>
        <nav>
          <NavLink to='/members/students'>
            {({ isActive }) => (
              <button className={classNames({ [classes.isActive]: isActive })}>Students</button>
            )}
          </NavLink>
          <NavLink to='/members/families'>
            {({ isActive }) => (
              <button className={classNames({ [classes.isActive]: isActive })}>Families</button>
            )}
          </NavLink>
        </nav>

        <section className={classes.stats}>
          <div className={classes.card}>
            <div className={classes.data}>
              <span>Students</span>
              <strong>{studentsCount ?? '...'}</strong>
            </div>
            <PersonIcon width={26} height={26} color={colors.slateGray} />
          </div>
          <div className={classes.card}>
            <div className={classes.data}>
              <span>Families</span>
              <strong>{familiesCount ?? '...'}</strong>
            </div>
            <FamilyIcon width={26} height={26} color={colors.slateGray} />
          </div>
          <div className={classes.card}>
            <div className={classes.data}>
              <span>Active</span>
              <strong>{activeStudentsCount ?? '...'}</strong>
            </div>
            <PersonIcon width={26} height={26} color={colors.slateGray} />
          </div>
        </section>
      </div>
      {isMembersDataLoaded ? (
        <Outlet context={{ loadedStudentsData, loadedFamiliesData }} />
      ) : (
        <div className='h-100 d-flex align-items-center justify-content-center'>
          <Loader>Loading Members</Loader>
        </div>
      )}
    </section>
  )
}

export default MembersListLayout
